/**
 * Translate Guard
 * ---------------
 * Los traductores integrados del navegador (Google Translate en Chrome/Android,
 * Safari Translate en iOS) reemplazan nodos de texto del DOM por sus propios
 * <font> wrappers. Cuando React intenta luego remover o reordenar esos nodos
 * con removeChild/insertBefore lanza un NotFoundError que rompe la app entera
 * con "Error inesperado".
 *
 * Parche defensivo conocido (issue React #11538) que evita el crash sin
 * interferir con la traducción ni con el comportamiento normal del DOM.
 */
export function installTranslateGuard() {
  if (typeof Node === "undefined") return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return (child.parentNode as Node).removeChild(child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  } as typeof Node.prototype.removeChild;

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  } as typeof Node.prototype.insertBefore;
}
